<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">SDK初始化</h1>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			SDK初始化是使用SDK的第一步，
			在该过程中完成向系统申请内存、加载人脸识别模型、授权等操作，首次授权需访问外网。
		</p> -->
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">[eyeTool SKEyeSDK_InitWithApiKey:@"yourApiKey" apiSecret:@"yourApiSecret"];</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）apiKey：当前APP所申请的SKEye的API_KEY</p>
        <p class="doc_main_p">（2）apiSecret：当前APP所申请的SKEye的API_SECRET</p>
        
       
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">- (BOOL)application:(UIApplication *)application 
	didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
                 [self windowInit];
             //SDK初始化
             	[eyeTool SKEyeSDK_InitWithApiKey:@"yourApiKey" apiSecret:@"yourApiSecret"];
             return YES;
}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../components/authorityErrorCode'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-iOS','SDK初始化'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeios/SDKInitial.vue